import { CalculatorStyleTokens } from "@omni/ui/brand/productConfiguration/calculator/calculator.tokens";

export const CalculatorStyles: CalculatorStyleTokens = {
    submitButton: {
        color: "secondary"
    }
};
